import { gsap } from "gsap";
import MouseFollower from "mouse-follower";
import Component from "../lib/Component";
import { isMobile } from "../lib/Utils";

export default class Cursor extends Component {
	constructor() {
		super(".js-custom-cursor");
	}

	initialize() {
		MouseFollower.registerGSAP(gsap);

		if (!isMobile()) {
			var cursor = new MouseFollower();
		}
	}
}
